import { LayerGroupNode } from './LayerGroupNode';
import { RootNode } from './RootNode';
import { APILayer, Node, NodeStatus } from './types';

export class LayerNode implements Node {
  readonly parent: LayerGroupNode | RootNode;
  readonly children = undefined;
  readonly childrenStatus = NodeStatus.loaded;
  readonly error: string | undefined = undefined;
  private _layer: APILayer;

  constructor(layer: APILayer, parent: LayerGroupNode | RootNode) {
    this._layer = layer;
    this.parent = parent;
  }

  get layer(): APILayer {
    return JSON.parse(JSON.stringify(this._layer));
  }

  get name() {
    return this._layer.layer_name;
  }

  get description() {
    return this._layer.description;
  }

  get imageSrc(): string | undefined {
    return this._layer?.icon;
  }
}
